import { Quote, Building2 } from "lucide-react";

const items = [
    {
        quote:
            "En 3 semaines, mon fils a complètement changé son rapport aux devoirs. Il s'y met seul, sans négociation. La méthode est simple et les résultats sont là.",
        author: "Sophie M.",
        role: "Maman de Lucas, 9 ans",
        initial: "S",
        accent: "bg-brand-500",
    },
    {
        quote:
            "J'avais du mal à me concentrer et je m'énervais vite. Maintenant j'utilise la technique STOP et je gère mieux mes émotions. Mes notes ont remonté.",
        author: "Théo",
        role: "15 ans, lycéen",
        initial: "T",
        accent: "bg-pinky-500",
    },
    {
        quote:
            "Nous avons fait appel à Boostez Vos Neurones pour accompagner des élèves en difficulté. Les retours des enseignants et des familles sont unanimes : une approche efficace et bienveillante.",
        author: "Marie-Claire D.",
        role: "Adjointe au Maire, chargée de l'Éducation",
        initial: "M",
        accent: "bg-ink-800",
        institution: true,
    },
    {
        quote:
            "Ma fille était accro aux écrans et ses résultats chutaient. Grâce au programme, elle a retrouvé un équilibre et surtout confiance en elle.",
        author: "Karim B.",
        role: "Papa d'Inès, 12 ans",
        initial: "K",
        accent: "bg-brand-600",
    },
];

export default function Testimonials() {
    return (
        <section
            id="temoignages"
            data-testid="testimonials-section"
            className="py-24 sm:py-32 bg-white"
        >
            <div className="container-wide">
                <div className="text-center max-w-2xl mx-auto">
                    <span className="eyebrow-brand">Témoignages</span>
                    <h2 className="display-2 mt-4">Ils nous font confiance.</h2>
                    <p className="body-lg mt-5">
                        Parents, jeunes et institutions témoignent des résultats obtenus.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-2 gap-6">
                    {items.map((t, i) => (
                        <figure
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="soft-card p-8 sm:p-10 transition-all hover:-translate-y-1 hover:shadow-[0_24px_60px_-30px_rgba(15,23,42,0.18)]"
                        >
                            <Quote className="h-7 w-7 text-brand-200" strokeWidth={2} />
                            <blockquote className="mt-5 text-lg leading-relaxed text-ink-800">
                                « {t.quote} »
                            </blockquote>
                            <figcaption className="mt-7 flex items-center gap-4">
                                <span
                                    className={`h-12 w-12 rounded-full grid place-items-center text-white font-bold text-lg ${t.accent}`}
                                >
                                    {t.initial}
                                </span>
                                <div className="flex-1">
                                    <p className="font-semibold text-ink-900">{t.author}</p>
                                    <p className="text-sm text-ink-500">{t.role}</p>
                                </div>
                                {t.institution && (
                                    <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-full bg-ink-900 text-white">
                                        <Building2 className="h-3 w-3" strokeWidth={2} /> Institution
                                    </span>
                                )}
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
